// Actions
import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for NotificationStore, for use in the registry */ export const NotificationStoreActionTypes = [
    ActionType.ShowNotificationAction,
    ActionType.ClearCurrentNotificationAction
];
